var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-dialog",
    {
      attrs: {
        fullscreen: "",
        eager: "",
        transition: "dialog-bottom-transition"
      },
      model: {
        value: _vm.openDialog,
        callback: function($$v) {
          _vm.openDialog = $$v
        },
        expression: "openDialog"
      }
    },
    [
      _c(
        "v-toolbar",
        { attrs: { color: "purple", flat: "", dark: "" } },
        [
          _c("span", [_vm._v("Pt Cash Voucher")]),
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              attrs: { text: "", small: "", dense: "" },
              on: {
                click: function($event) {
                  _vm.openDialog = false
                }
              }
            },
            [_c("v-icon", [_vm._v("mdi-close")])],
            1
          )
        ],
        1
      ),
      _c(
        "v-card",
        [
          _c(
            "v-overlay",
            { attrs: { value: _vm.ptCashVoucherShowGetting, absolute: "" } },
            [
              _c("v-progress-circular", {
                attrs: { indeterminate: "", size: "60" }
              })
            ],
            1
          ),
          _c(
            "v-container",
            { attrs: { fluid: "" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "PT Cash NO.",
                                  text:
                                    _vm.ptCashVoucherShowData
                                      .pt_cash_voucher_number
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: _vm.approvedRejectedTitle,
                                  text: _vm.approvedRejectedBy
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Address",
                                  text: _vm.ptCashVoucherShowData.address
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: {
                                  title: "Requested By",
                                  text:
                                    _vm.ptCashVoucherShowData.created_by.name
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "6" } },
                            [
                              _c("base-card", {
                                attrs: { title: "Pay To", text: _vm.payTo }
                              })
                            ],
                            1
                          ),
                          !_vm.approvedRejectedBy
                            ? _c(
                                "v-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "green",
                                        dark: "",
                                        dense: "",
                                        small: "",
                                        block: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "approve",
                                            _vm.ptCashVoucherId
                                          )
                                        }
                                      }
                                    },
                                    [_c("span", [_vm._v("Approve")])]
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          !_vm.approvedRejectedBy
                            ? _c(
                                "v-col",
                                { attrs: { cols: "2" } },
                                [
                                  _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        color: "error",
                                        dark: "",
                                        dense: "",
                                        small: "",
                                        block: ""
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.$emit(
                                            "reject",
                                            _vm.ptCashVoucherId
                                          )
                                        }
                                      }
                                    },
                                    [_c("span", [_vm._v("Reject")])]
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "6" } },
                    [
                      _c("v-simple-table", {
                        scopedSlots: _vm._u([
                          {
                            key: "default",
                            fn: function() {
                              return [
                                _c("thead", [
                                  _c("tr", [
                                    _c("th", [_vm._v("Account Code")]),
                                    _c("th", [_vm._v("Description")]),
                                    _c("th", { staticClass: "text-right" }, [
                                      _vm._v("Amount")
                                    ])
                                  ])
                                ]),
                                _c(
                                  "tbody",
                                  [
                                    _vm._l(
                                      _vm.ptCashVoucherShowData.details,
                                      function(item) {
                                        return _c("tr", { key: item.id }, [
                                          _c("th", [
                                            _vm._v(
                                              _vm._s(
                                                item.account_code.account_code
                                              )
                                            )
                                          ]),
                                          _c("td", [
                                            _vm._v(_vm._s(item.description))
                                          ]),
                                          _c(
                                            "th",
                                            { staticClass: "text-right" },
                                            [
                                              _vm._v(
                                                _vm._s(item.amount.phpFormat())
                                              )
                                            ]
                                          )
                                        ])
                                      }
                                    ),
                                    _c("tr", [
                                      _c("th", { attrs: { colspan: "2" } }, [
                                        _vm._v("Total")
                                      ]),
                                      _c("th", { staticClass: "text-right" }, [
                                        _vm._v(
                                          _vm._s(_vm.totalAmount.phpFormat())
                                        )
                                      ])
                                    ])
                                  ],
                                  2
                                )
                              ]
                            },
                            proxy: true
                          }
                        ])
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }